import { bootstrapApplication } from '@angular/platform-browser';

import {
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAppInitializer, inject, provideZoneChangeDetection } from '@angular/core';

import { OAuthService } from '@olameter/o-authentication';
import { NOTIFICATION_CONTAINER } from '@progress/kendo-angular-notification';
import { ElementRef } from '@angular/core';

import {
  provideNgxWebstorage,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage,
} from 'ngx-webstorage';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { environment } from './environments/environment';
import { OConfigService } from '@olameter/o-config-service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export function initConfig(appConfig: OConfigService) {
  return appConfig.loadConfigAsyn(
    environment.configLocation,
    environment.zkparentNode,
    environment.aclDigests
  );
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideAppInitializer(() => {
      const config = inject(OConfigService);
      return initConfig(config);
    }),
    {
      provide: NOTIFICATION_CONTAINER,
      useFactory: () => ({ nativeElement: document.body } as ElementRef),
    },
    provideNgxWebstorage(
      withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
      withLocalStorage(),
      withSessionStorage()
    ),
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    OAuthService,

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    })
  ],
}).catch((err) => console.error(err));

